import { getUrlParam } from '@/utils/helper';

export default {
  methods: {
    routeReplace(route, query, lang) {
      this.$router.replace({
        name: route,
        query: {
          ...query, lang,
        },
      });
    },

    getSurveyLang(res) {
      const lang = getUrlParam('lang') || 'zh-CHS';
      return res.meta?.configs?.language || lang;
    },
  },
};
